var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactListsFill = function SvgContactListsFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.625 1.667a2.29 2.29 0 0 0-2.292 2.291v12.084a2.29 2.29 0 0 0 2.292 2.291h7.917a3.125 3.125 0 0 0 3.125-3.125V4.792a3.125 3.125 0 0 0-3.125-3.125zM4.583 15.833v.209c0 .575.467 1.041 1.042 1.041h7.917a1.875 1.875 0 0 0 1.875-1.875v-1.249a3.1 3.1 0 0 1-1.875.624H5.833c-.69 0-1.25.56-1.25 1.25M7.292 5.208a.625.625 0 1 0 0 1.25h5.416a.624.624 0 1 0 0-1.25zm-.625 3.959c0-.346.279-.625.625-.625h2.916a.624.624 0 1 1 0 1.25H7.292a.625.625 0 0 1-.625-.625",
    clipRule: "evenodd"
  })));
};
export default SvgContactListsFill;